// extracted by mini-css-extract-plugin
module.exports = {"MyRewardsWrapper":"MyRewards_MyRewardsWrapper__18Bc_"};